import styled from "@emotion/styled";

export const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 24px 16px 20px 16px;
  width: 100%;
`;

export const TabBox = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`;
export const PauseBox = styled.div`
  display: flex;
  gap: 2px;
`;
export const PauseIcon = styled.div`
  width: 1px;
  height: 6px;
  border: 1px solid #939094;
  border-radius: 50px;
`;
